<template>
  <v-dialog v-model="internal" persistent max-width="560" overlay-opacity="0.7">
    <v-card class="pa-6">
      <!--broker-->
      <div v-if="typeOfCreation === 'broker'">
        <div class="d-flex align-center justify-space-between my-1">
          <h3>Create Broker</h3>
          <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card outlined class="pa-5">
          <div>
            <v-row class="justify-space-between">
              <v-col class="font-weight-black" md="3" cols="3">CNPJ</v-col>
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: 600">numbers</span>
                (00.000.000/0001-00)</v-col
              >
            </v-row>
            <v-row class="justify-space-between">
              <v-col
                class="font-weight-black"
                style="white-space: nowrap"
                md="3"
                cols="3"
                >Company Name</v-col
              >
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: 600">string</span> (PEPSI Co.)</v-col
              >
            </v-row>
            <v-row class="justify-space-between">
              <v-col class="font-weight-black" md="3" cols="3"> Email</v-col>
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: 600">string</span>
                (renato@pepsi.com)</v-col
              >
            </v-row>
          </div>
        </v-card>
        <div>
          <v-form ref="form" class="my-5 mx-2">
            <v-text-field
              data-testid="create-broker-cnpj"
              required
              dense
              :rules="[(v) => !!v || 'This field is required']"
              maxLength="18"
              @keypress="blockNonNumeric"
              @input="formatCNPJ"
              v-model="broker.cnpj"
              label="CNPJ*"
            ></v-text-field>

            <v-text-field
              data-testid="create-broker-name"
              required
              dense
              :rules="[(v) => !!v || 'This field is required']"
              maxLength="40"
              v-model="broker.name"
              label="Name*"
            ></v-text-field>

            <v-text-field
              data-testid="create-broker-email"
              required
              dense
              v-model="broker.email"
              :rules="[(v) => /.+@.+\..+/.test(v) || 'Invalid email']"
              label="Email*"
            ></v-text-field>

            <v-text-field
              data-testid="create-broker-password"
              required
              dense
              type="password"
              autocomplete="new-password"
              :rules="[(v) => !!v || 'This field is required']"
              maxLength="15"
              v-model="broker.passwd"
              label="Password*"
            ></v-text-field>
            <div>
              <div class="d-flex align-center justify-space-between">
                <v-checkbox
                  data-testid="create-broker-partner"
                  dense
                  v-model="partner"
                  label="Is Partner"
                ></v-checkbox>
                <div v-if="partner" class="broker-master-field">
                  <v-autocomplete
                    data-testid="create-broker-master"
                    required
                    dense
                    outlined
                    clearable
                    :items="formatBrokerList"
                    item-text="searchText"
                    item-value="value"
                    v-model="broker.masterCnpj"
                    label="Broker Master*"
                    placeholder="Search by name, CNPJ, or email"
                    prepend-inner-icon="mdi-magnify"
                    :menu-props="brokerMenuProps"
                  >
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item v-bind="attrs" v-on="on">
                        <v-list-item-content>
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                          <v-list-item-subtitle>
                          {{ item.formattedCnpj }}<span v-if="item.email"> · {{ item.email }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span>{{ item.name }}</span>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content class="grey--text">No matching master brokers</v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
              <v-autocomplete
                data-testid="create-broker-banks"
                required
                label="Banks"
                placeholder="Search banks by name, CNPJ, code, or email"
                v-model="broker.banklist"
                dense
                outlined
                multiple
                clearable
                chips
                deletable-chips
                prepend-inner-icon="mdi-magnify"
                :items="formattedBankOptions"
                item-text="searchText"
                item-value="id"
                :menu-props="brokerMenuProps"
              >
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-action>
                      <v-checkbox :input-value="attrs.inputValue" color="primary" />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.formattedCnpj }}
                        <span v-if="item.bankCode"> · Code {{ item.bankCode }}</span>
                        <span v-if="item.email"> · {{ item.email }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2" small close @click:close="removeBank(item.id)">
                    {{ item.name }}
                  </v-chip>
                  <span v-else-if="index === 2" class="caption grey--text ml-1">
                    +{{ broker.banklist.length - 2 }} more
                  </span>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content class="grey--text">No matching banks</v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
          </v-form>
        </div>
      </div>

      <!--bank form-->
      <div v-else>
        <div class="d-flex align-center justify-space-between my-1">
          <h3>Create Bank</h3>
          <v-btn icon @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card outlined class="pa-5">
          <div>
            <v-row class="justify-space-between">
              <v-col
                style="white-space: nowrap"
                class="font-weight-black"
                md="3"
                cols="3"
                >Bank CNPJ</v-col
              >
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: bold">numbers</span>
                (00.000.000/0001-00)</v-col
              >
            </v-row>
            <v-row class="justify-space-between">
              <v-col
                class="font-weight-black"
                style="white-space: nowrap"
                md="3"
                cols="3"
                >Bank Name</v-col
              >
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: 600">string</span> (Bank of
                America)</v-col
              >
            </v-row>
            <v-row class="justify-space-between">
              <v-col
                class="font-weight-black"
                style="white-space: nowrap"
                md="3"
                cols="3"
              >
                Bank Code</v-col
              >
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: 600">string</span> (3 digits)</v-col
              >
            </v-row>
            <v-row class="justify-space-between">
              <v-col class="font-weight-black" md="3" cols="3"> Email</v-col>
              <v-col style="text-align: end" md="8" cols="8"
                ><span style="font-weight: 600">string</span>
                (renato@pepsi.com)</v-col
              >
            </v-row>
          </div>
        </v-card>
        <div>
          <v-form ref="form" class="my-5 mx-2">
            <v-text-field
              data-testid="create-bank-cnpj"
              required
              dense
              :rules="[(v) => !!v || 'This field is required']"
              maxLength="18"
              @keypress="blockNonNumeric"
              @input="formatCNPJ"
              v-model="bank.cnpj"
              label="CNPJ*"
            ></v-text-field>

            <v-text-field
              data-testid="create-bank-name"
              required
              dense
              :rules="[(v) => !!v || 'This field is required']"
              maxLength="40"
              v-model="bank.name"
              label="Name*"
            ></v-text-field>

            <v-text-field
              data-testid="create-bank-code"
              required
              dense
              maxLength="3"
              v-model="bank.bankCode"
              :rules="[(v) => !!v || 'This field is required']"
              label="Bank Code*"
            ></v-text-field>

            <v-text-field
              data-testid="create-bank-email"
              required
              dense
              v-model="bank.email"
              :rules="[(v) => /.+@.+\..+/.test(v) || 'Invalid email']"
              label="Email*"
            ></v-text-field>
            <v-text-field
              data-testid="create-bank-password"
              required
              dense
              type="password"
              autocomplete="new-password"
              :rules="[(v) => !!v || 'This field is required']"
              maxLength="15"
              v-model="bank.passwd"
              label="Password*"
            ></v-text-field>
            
            <v-autocomplete
              required
              label="Brokers"
              placeholder="Search brokers by name, CNPJ, or email"
              v-model="bank.brokerlist"
              dense
              outlined
              multiple
              clearable
              chips
              deletable-chips
              prepend-inner-icon="mdi-magnify"
              :items="formattedBrokerOptions"
              item-text="searchText"
              item-value="id"
              :menu-props="brokerMenuProps"
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-bind="attrs" v-on="on">
                  <v-list-item-action>
                    <v-checkbox :input-value="attrs.inputValue" color="primary" />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.formattedCnpj }}<span v-if="item.email"> · {{ item.email }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 2" small close @click:close="removeBroker(item.id)">
                  {{ item.name }}
                </v-chip>
                <span v-else-if="index === 2" class="caption grey--text ml-1">
                  +{{ bank.brokerlist.length - 2 }} more
                </span>
              </template>
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content class="grey--text">No matching brokers</v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>

          </v-form>
        </div>
      </div>

      <div class="d-flex flex-gap-2 justify-end mt-4">
        <v-btn small outlined @click="closeModal">Cancel</v-btn>
        <v-btn
          data-testid="confirm-create"
          :loading="createLoading"
          :disabled="formatDisabling"
          small
          color="primary"
          @click="brokerCreate"
          >Create</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import convertToCNPJ from "@/utils";

export default {
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    typeOfCreation: {
      type: String,
      default: "",
    },
    brokerList:{
      type:Array,
    },
    bankList:{
      type:Array
    }
  },
  data() {
    return {
      bankCode: null,
      broker: {
        name: "",
        email: "",
        banklist:[],
        role:'',
        passwd: "",
        cnpj: "",
        masterCnpj: "",
      },
      partner: false,
      bank: {
        name: "",
        bankCode: "",
        brokerlist: [],
        cnpj: "",
        role:'',
        passwd: "",
        email: "",
      },
      snackbar: {
        show: false,
        message: "",
        color: "green",
      },
      createLoading: false,
      brokerMenuProps: {
        maxHeight: 360,
        closeOnContentClick: false,
        offsetY: true,
      },
    };
  },
  watch: {
    value(val) {
      this.internal = val;
      this.$nextTick(() => {
        this.$refs.form?.reset();
        this.createLoading = false;
      });
    },
  },
  methods: {
    blockNonNumeric(e) {
      const allowed = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Escape",
      ];
      if (allowed.includes(e.key)) return;
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    },
    brokerCreate() {
      this.createLoading = true;
      let payload = {};
      if (this.typeOfCreation === "broker") {
        payload = {
          name: this.broker.name,
          email: this.broker.email,
          banklist: this.broker.banklist,
          cnpj: this.broker.cnpj.replace(/\D/g, ""),
          role: this.partner? 'partner' : 'broker',
          passwd: this.broker.passwd,
          partmaster_cnpj: this.partner
            ? this.broker.masterCnpj.replace(/\D/g, "")
            : null,
        };
      } else {
        payload = {
          name: this.bank.name,
          email: this.bank.email,
          passwd : this.bank.passwd,
          brokerlist: this.bank.brokerlist,
          cnpj: this.bank.cnpj.replace(/\D/g, ""),
          role: 'bank',
          bankcode: this.bank.bankCode,
        };
      }

      this.$emit("created", payload);
    },
    closeModal() {
      this.createLoading = false;
      this.broker = {
        name: "",
        email: "",
        passwd: "",
        banklist:[],
        role:'',
        cnpj: "",
        partner: false,
        partmaster_cnpj: "",
      };
      (this.bank = {
        name: "",
        bankCode: "",
        brokerlist: [],
        cnpj: "",
        email: "",
        passwd: "",
        role:'',
      }),
        this.$refs.form?.reset();
      this.internal = false;
      this.$emit("input", false);
    },
    formatCNPJ() {
      if (this.typeOfCreation === "broker") {
        let formatted = convertToCNPJ(this.broker.cnpj);
        this.broker.cnpj = formatted;
      } else {
        let formatted = convertToCNPJ(this.bank.cnpj);
        this.bank.cnpj = formatted;
      }
    },
    formatCNPJMaster() {
      let formatted = convertToCNPJ(this.broker.masterCnpj);
      this.broker.masterCnpj = formatted;
    },
    removeBroker(brokerId) {
      this.bank.brokerlist = this.bank.brokerlist.filter(id => id !== brokerId)
    },
    removeBank(bankId) {
      this.broker.banklist = this.broker.banklist.filter(id => id !== bankId)
    },
  },
  computed: {
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    formatBrokerList() {
      return (this.brokerList || [])
        .filter(bro => bro.partmaster_id === 0)
        .map(bro => ({
          searchText: `${bro.name || ''} ${bro.cnpj || ''} ${convertToCNPJ(bro.cnpj || '')} ${bro.email || ''}`,
          name: bro.name,
          formattedCnpj: convertToCNPJ(bro.cnpj || ''),
          email: bro.email || '',
          value: bro.cnpj,
        }))
    },
    formattedBrokerOptions() {
      return (this.brokerList || []).map(broker => ({
        ...broker,
        formattedCnpj: convertToCNPJ(broker.cnpj || ''),
        searchText: `${broker.name || ''} ${broker.cnpj || ''} ${convertToCNPJ(broker.cnpj || '')} ${broker.email || ''}`,
      }))
    },
    formattedBankOptions() {
      return (this.bankList || []).map(bank => {
        const bankCode = bank.bankCode || bank.bankcode || ''
        const formattedCnpj = convertToCNPJ(bank.cnpj || '')
        return {
          ...bank,
          bankCode,
          formattedCnpj,
          searchText: `${bank.name || ''} ${bank.cnpj || ''} ${formattedCnpj} ${bankCode} ${bank.email || ''}`,
        }
      })
    },
    checkEmail() {
      return /.+@.+\..+/.test(this.broker.email);
    },
    checkCnpj() {
      if (this.typeOfCreation === "broker") {
        return this.broker.cnpj.replace(/\D/g, "").length === 14;
      }
      return this.bank.cnpj.replace(/\D/g, "").length === 14;
    },
    formatDisabling() {
      if (this.typeOfCreation === "broker") {
        return (
          !this.broker.name ||
          !this.checkEmail ||
          !this.broker.passwd ||
          !this.checkCnpj ||
          this.createLoading ||
          (this.partner && !this.broker.masterCnpj)
        );
      }
      return (
        !this.bank.name ||
        !this.checkCnpj ||
        !this.bank.bankCode ||
        this.createLoading
      );
    },
  },
};
</script>

<style scoped>
.broker-master-field {
  flex: 1;
  min-width: 300px;
  margin-left: 16px;
}

.broker-option {
  line-height: 1.2;
}
</style>
